import axios from '@/service/request';
import type { R, ChannelTypeEnum } from './types';

/**
 * 手机号/邮箱注册请求参数
 */
export interface MiniRegisterRequest {
  /** 手机国内号码或邮箱 */
  account?: string;
  /** 手机国际区号（如 +86），邮箱注册不传 */
  countryRegionCode?: string;
  /** 密码 */
  password?: string;
  /** 确认密码 */
  confirmPassword?: string;
  /** 验证码 */
  captcha?: string;
  /** 注册渠道 */
  channel?: ChannelTypeEnum;
  /** 是否同意注册协议. true-同意. false-不同意 */
  agreeProtocol?: boolean;
}

/**
 * 手机号/邮箱注册
 */
export const apiBuyerRegister = (data: MiniRegisterRequest): Promise<R<string>> => {
  return axios.post('/buyer/register', data);
};

